import { Breadcrumb } from '@chakra-ui/react';
import React from 'react';

interface IProps {
  data: { title: string; link?: string }[];
  /** When true, the last crumb is rendered as the page <h1> (SEO 5.5). */
  lastAsH1?: boolean;
}

const Breadcrumbs = ({ data, lastAsH1 = false }: IProps) => {
  return (
    <Breadcrumb.Root my={6}>
      <Breadcrumb.List gap={3}>
        {data.map(({ title, link }, index) => {
          const isLast = index === data.length - 1;

          return (
            <React.Fragment key={index}>
              <Breadcrumb.Item fontSize='14px' lineHeight='20px'>
                {isLast ? (
                  <Breadcrumb.CurrentLink
                    as={lastAsH1 ? 'h1' : undefined}
                    color='primary'
                    fontWeight={600}
                    fontSize='14px'
                    lineHeight='20px'
                  >
                    {title}
                  </Breadcrumb.CurrentLink>
                ) : (
                  <Breadcrumb.Link
                    href={link ? link : undefined}
                    color='gray.800'
                    fontWeight={500}
                  >
                    {title}
                  </Breadcrumb.Link>
                )}
              </Breadcrumb.Item>
              {!isLast && <Breadcrumb.Separator color={'text.muted'} />}
            </React.Fragment>
          );
        })}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  );
};

export default Breadcrumbs;
